import React from 'react';
import SearchSimple from "../../../../../components/SearchSimples/SearchSimple";
import CustomTable from "../../../../../components/table/CustomTable";
import DeleteModal from "../../../../Modals/DeleteModal";
import MainOutputTableApp from "../Functionality/MainOutputTableApp";
import CreateOutputModal from "../Modal/CreateOutputModal";
import {permissionObj} from "../../../../../Helpers/permission";
import CustomButtonLink from "../../../../../components/buttons/CustomButtonLink";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const MainOutputTable = (props) => {
    const {
        deleteModalShow,
        setDeleteModalShow,
        createModalShow,
        setCreateModalShow,
        selectedList,
        setSelectedList
    } = props;

    const {
        t,
        DEV,
        permission,
        tableId,
        searchId,
        thead,
        tbody,
        pagination,
        rowsPerPage,
        setResults,
        option,
        searchElement,
        setSearchElement,
        setSearch,
        setBodyForExport,
        setSimpleSearch,
        deletePermission,
        isAllChecked,
        setModified,
        handleCheckboxChange,
        handleDeleteAll,
        deleteSelectedOutputs
    } = MainOutputTableApp({
        selectedList,
        setSelectedList
    });

    return (
        <>
            <SearchSimple
                id={"txt_mot_search"}
                setSearchResults={setResults}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                setBodyForExport={setBodyForExport}
                contractorId={null}
                supplierId={null}
                setSimpleSearch={setSimpleSearch}
                setSearch={setSearch}
            />

            <CustomTable tableId={tableId}
                         searchId={searchId}
                         checkbox={deletePermission}
                         checkboxTitle={"de_/_select_all"}
                         isAllChecked={isAllChecked}
                         onChangeCheckbox={handleDeleteAll}
                         thead={thead}
                         tbody={tbody}
                         columnActions={false}
                         handleCheckboxChange={handleCheckboxChange}
                         selectedList={selectedList}
                         childrenNotInformation={tbody?.data?.length === 0 ? <>
                                 <div className={"warning-text"}>
                                     <p>{t("you_haven_not_created_any_output_yet")}</p>
                                 </div>
                                 { (DEV || permission?.includes(permissionObj?.WEB_HID_CREATE)) &&
                                 <CustomButtonLink splitName={false} id={'btn_mot_create'} card={true}
                                                   onClick={() => setCreateModalShow(true)}
                                                   name={'create_output'}/>
                                 } </>
                             : undefined
                         }
            />

            {pagination()}

            {createModalShow &&
                <CreateOutputModal
                    onHide={()=>setCreateModalShow(false)}
                    show={createModalShow}
                    setModified={setModified}
                />
            }

            <DeleteModal
                show={deleteModalShow}
                onHide={() => setDeleteModalShow(false)}
                onClickFn={() => deleteSelectedOutputs()}
                data={selectedList}
                title_modal={t('delete_output')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t('outputs')}
            />

        </>
    );
};

export default MainOutputTable;
